export default __webpack_public_path__ + "static/media/about-you.102bf327.svg";